// Transient hand-off for a file chosen via the home "+ Datei hochladen" quick
// action. The file dialog must open from the home click (a real user gesture),
// but the upload itself belongs to ServicePage's existing flow - so the picked
// files are stashed here and consumed once by ServicePage on mount. In-memory
// and module-level on purpose: File objects can't ride in a URL, and this never
// needs to survive a reload.

let pending: File[] | null = null;

export function setPendingUpload(files: File[]): void {
  pending = files;
}

// Returns the stashed files once, then clears them (so a normal visit to
// ServicePage doesn't re-trigger an upload).
export function takePendingUpload(): File[] | null {
  const files = pending;
  pending = null;
  return files;
}
